var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.items && _vm.data.items.length)?_c('AppCarousel',{attrs:{"slides":_vm.data.items,"unique-id":_vm.uid}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }